import { useRealTimeTypedQuery } from "components";
import { useTagsListeners } from "modules/TagsDashboard/listeners";
import { TagsDashboardQueryKeys } from "modules/TagsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { capitalizeFirstLetter, convertSnakeCaseToWords } from "utils/common";

import type { Tag } from "models";

const formatTags = (tags: Tag[]) =>
  tags.map(tag => ({ ...tag, name: capitalizeFirstLetter(convertSnakeCaseToWords(tag.name)) })).sort((a, b) => b.created_on.localeCompare(a.created_on));

export const useTagsQuery = () => {
  const listeners = useTagsListeners();

  return useRealTimeTypedQuery({
    queryKey: TagsDashboardQueryKeys.tags,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.tags,
    select: formatTags,
    listeners
  });
};
